/// <amd-module name="typeahead/core/SuggestServiceParamModifier" />

import {ConfigurableFeature} from "ConfigurableFeature";
import {IOverrideParams} from "typeahead/core/IOverrideParams";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";

export abstract class SuggestServiceParamModifier extends ConfigurableFeature {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IOverrideParams):
            JQueryPromise<ISuggestServiceQueryParams> {
        let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
        this.shouldOverride(options)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    this.modify(params, context, options);
                }
                deferred.resolve(params);
            })
            .fail(() => {
                if (this.precondition(params, context, options)) {
                    ExecutionHelper.shouldExecute(context, this.configuration)
                        .done((shouldExecute) => {
                            if (shouldExecute) {
                                this.modify(params, context, options);
                            }
                            deferred.resolve(params);
                        });
                } else {
                    deferred.resolve(params);
                }
            });
        return deferred.promise();
    }
    public addFeatureFlag(params: ISuggestServiceQueryParams, feature: string) {
        params.features = params.features && params.features.length && params.features.push ?
            params.features || [] : [];
        if (params.features.indexOf(feature) < 0) {
            params.features.push(feature);
        }
    }
    public addRegionType(params: ISuggestServiceQueryParams, regionType: number) {
        /* tslint:disable-next-line: no-bitwise */
        params.mask |= regionType;
    }
    protected precondition(params: ISuggestServiceQueryParams, context: IContext, options: any): boolean {
        return typeof params !== "undefined";
    }
    protected abstract modify(params: ISuggestServiceQueryParams, context: IContext, options: any);
}
